import React from 'react';
import HeadingDescription from '../HeadingDescription';
import TechnicalDataTable from '../TechnicalDataTable';
import TankProcessFlow from './TankProcessFlow';
import ProposalImage from '../ProposalImage';
import { getTableData } from './utils';

export default function PreTreatmentLine({ recoveryBoothContent, recoverySpec, ptSpec, ptStepsData, uploadedImage }) {
  const hasRecovery = recoveryBoothContent || recoverySpec;
  const hasPt = ptSpec || ptStepsData?.steps;

  if (!hasRecovery && !hasPt) return null;

  return (
    <div className="a4-paddings quotation-page quotation-page-compact">
      <div className="quotation-page-inner quotation-bg-light">
        {ptSpec && (
          <div className="quotation-section-block">
            <HeadingDescription heading="Pre Treatment Process" description="" level={2} />
            {uploadedImage && (
              <ProposalImage
                src={uploadedImage}
                wrapperStyle={{ marginBottom: 12 }}
                imgStyle={{ maxHeight: 500, width: 'auto', objectFit: 'contain' }}
              />
            )}
            {ptStepsData?.steps && (
              <TankProcessFlow steps={ptStepsData.steps} title="Tank Process" />
            )}
            <TechnicalDataTable data={getTableData(ptSpec)} title={ptSpec?.label || 'Technical Specifications'} />
          </div>
        )}

      </div>
    </div>
  );
}
